import { render } from "./FacialHarmonizationContentEn.vue?vue&type=template&id=73944526&scoped=true"
import script from "./FacialHarmonizationContentEn.vue?vue&type=script&lang=js"
export * from "./FacialHarmonizationContentEn.vue?vue&type=script&lang=js"

import "./FacialHarmonizationContentEn.vue?vue&type=style&index=0&id=73944526&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73944526"]])

export default __exports__